
export type HistoricalPeriod = {
  id: number;
  name: string;
  months: number;
};

export const historicalPeriodMap: HistoricalPeriod[] = [
  { id: 0, name: '3 months', months: 3 },
  { id: 1, name: '6 months', months: 6 },
  { id: 2, name: '1 year', months: 12 },
  { id: 3, name: '3 years', months: 36 },
  { id: 4, name: '5 years', months: 60 },
  { id: 5, name: '7 years', months: 84 }
];
